export function convertSchedule(input: any) {
  return Object.entries(input).map(([day, time]: any) => {
    const [fromHour, fromMinute] = time.from.split(':').map(Number);
    const [toHour, toMinute] = time.to.split(':').map(Number);

    return {
      day: parseInt(day),
      from: {
        hour: fromHour,
        minute: fromMinute / 15 + 2,
      },
      to: {
        hour: toHour,
        minute: toMinute / 15 + 2,
      },
    };
  });
}
